export default __webpack_public_path__ + "static/media/ccl.530f3a73.jpg";